import React from 'react';
import { Phone, TrendingUp, Globe, DollarSign, Clock, Users } from 'lucide-react';
import './Features.css';

const Features = () => {
  const features = [
    {
      id: 1,
      icon: <Phone size={32} />,
      title: 'Never Miss a Call',
      description: 'AI voice agents handle calls, reservations, and orders 24/7 automatically.',
    },
    {
      id: 2,
      icon: <TrendingUp size={32} />,
      title: 'Boost Revenue',
      description: 'Capture after-hours and missed-call orders that would otherwise be lost.',
    },
    {
      id: 3,
      icon: <Globe size={32} />,
      title: 'Multi-Language Support',
      description: 'Engage customers naturally in any language with fluent AI conversations.',
    },
    {
      id: 4,
      icon: <DollarSign size={32} />,
      title: 'Cut Operational Costs',
      description: 'Reduce phone handling costs up to 40% with flexible pay-per-use pricing.',
    },
    {
      id: 5,
      icon: <Clock size={32} />,
      title: 'Instant Response',
      description: 'Answer every call in under 2 seconds with zero wait times or hold music.',
    },
    {
      id: 6,
      icon: <Users size={32} />,
      title: 'Smart Insights',
      description: 'Track call volumes, peak hours, and customer preferences automatically.',
    }
  ];

  return (
    <section className="features-section" id="features">
      <div className="features-container">
        <div className="features-header">
          <p className="features-label">WHY AUTOMETA</p>
          <h2 className="features-title">
            Everything You Need to Automate Your Business Calls
          </h2>
          <p className="features-subtitle">Our AI handles the calls, you handle the business. It's that simple.</p>
        </div>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div
              key={feature.id}
              className="feature-card"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
